export interface ISortBy {
    id: string,
    desc?: boolean
}